/**
 * Return DOM element which contains content parsed from provided string
 * @param html	input HTML content
 */
export function fromString(html:string):HTMLElement {
	if (html == null || html.trim().length === 0) {
		return document.createElement("p");
	}
	if (!isHtmlFragment(html)) {
		// Make it HTML
		html = convertPlainTextToHtml(html);
	}
	const parser = new DOMParser();
	const htmlDoc = parser.parseFromString(html, "text/html");
	return htmlDoc.querySelector("body");
}


function isHtmlFragment(content: string): boolean {
	// Trim to remove leading/trailing spaces
	const trimmed = content.trim();

	// Basic checks for presence of HTML tags
	const hasTags = /<\/?[a-z][\s\S]*>/i.test(trimmed);

	// Checking for HTML entities or attributes (common in HTML)
	const hasAttributes = /<[a-z]+\s+[^>]+>/i.test(trimmed);

	// Ensuring it’s not just a single < or > character
	const looksLikePlainText = /^[^<>]+$/.test(trimmed);

	return hasTags || hasAttributes || !looksLikePlainText;
}


function convertPlainTextToHtml(plainText: string): string {
	// Escape HTML special characters
	const escapeHtml = (text: string) =>
		text.replace(/&/g, "&amp;")
			.replace(/</g, "&lt;")
			.replace(/>/g, "&gt;");

	// Detect URLs and convert them to <a> tags
	const urlRegex = /(https?:\/\/[^\s]+)/g;
	const convertLinks = (text: string) =>
		text.replace(urlRegex, (url) => `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`);

	// Split into paragraphs by double newlines
	const paragraphs = plainText
		.trim()
		.split(/\n{2,}/)
		.map(paragraph =>
			`<p>${convertLinks(escapeHtml(paragraph).replace(/\n/g, "<br>"))}</p>`
		);

	return paragraphs.join("\n");
}
